import React from 'react';
import './Accordion.css'

const Accordion = ({ articleObj }) => {
    var content = articleObj;
    return (
        <>
        <div className={`${content.attributes.articleRendering} ${content.attributes.class} accordion-div`}>
            <div className="accordion accordion-div" id={"accordion"+content.contentId}>
                <div className="accordion-item accordion-item-div">
                    <h2 className="accordion-header" id={"headingOne"+content.contentId}>
                        <button className="accordion-button accordion-icon accordion-button-text collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapseOne"+content.contentId} aria-expanded="false" aria-controls={"collapseOne"+content.contentId}>
                          <p className="accordion-p" dangerouslySetInnerHTML={{ __html: content.title }} ></p>
                        </button>
                    </h2>
                    <div id={"collapseOne"+content.contentId} className="accordion-collapse collapse" aria-labelledby={"headingOne"+content.contentId} data-bs-parent={"#accordion"+content.contentId}>
                        <div className="accordion-body accordion-body-content">
                            <p className="accordion-p" dangerouslySetInnerHTML={{ __html: content.body }} ></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Accordion